export default __webpack_public_path__ + "static/media/7.8a4d7073.mp3";